import { RegionType } from './RegionType';

export const USOA_REGION_ID = '77fdfc56-826b-4cab-976c-175acb54e97a';
export const APAC_REGION_ID = 'e6bcb256-4616-4cf6-b6ef-b45ffd10849a';
export const EMEA_REGION_ID = '5e1f0a58-0754-42fa-b86f-bfdf0b1925e8';
export const LATM_REGION_ID = 'bb182bf1-ce66-4d5d-b249-f4e9e81be13d';

export const USOA_ABBREVIATION = 'USOA';
export const APAC_ABBREVIATION = 'APAC';
export const EMEA_ABBREVIATION = 'EMEA';
export const LATM_ABBREVIATION = 'LATM';

export const APAC_EM_ABBREVIATION = 'Asia';
export const EMEA_EM_ABBREVIATION = 'CEEMEA';

export const RegionAbbreviationById = {
  [USOA_REGION_ID]: USOA_ABBREVIATION,
  [APAC_REGION_ID]: APAC_ABBREVIATION,
  [EMEA_REGION_ID]: EMEA_ABBREVIATION,
  [LATM_REGION_ID]: LATM_ABBREVIATION,
} as const;

export const RegionIdByAbbreviation = {
  [USOA_ABBREVIATION]: USOA_REGION_ID,
  [APAC_ABBREVIATION]: APAC_REGION_ID,
  [EMEA_ABBREVIATION]: EMEA_REGION_ID,
  [LATM_ABBREVIATION]: LATM_REGION_ID,
} as const;

export const RegionIdByEmAbbreviation = {
  [APAC_EM_ABBREVIATION]: APAC_REGION_ID,
  [EMEA_EM_ABBREVIATION]: EMEA_REGION_ID,
} as const;

export const RegionSortOrder = {
  [USOA_ABBREVIATION]: 0,
  [APAC_ABBREVIATION]: 1,
  [EMEA_ABBREVIATION]: 2,
  [LATM_ABBREVIATION]: 3,
} as const;

export const RegionIdToTypeMap: Record<string, RegionType> = {
  [USOA_REGION_ID]: RegionType.USOA,
  [APAC_REGION_ID]: RegionType.APAC,
  [EMEA_REGION_ID]: RegionType.EMEA,
  [LATM_REGION_ID]: RegionType.LATM,
} as const;

export const RegionAbbreviationToTypeMap: Record<string, RegionType> = {
  [USOA_ABBREVIATION]: RegionType.USOA,
  [APAC_ABBREVIATION]: RegionType.APAC,
  [EMEA_ABBREVIATION]: RegionType.EMEA,
  [LATM_ABBREVIATION]: RegionType.LATM,
} as const;
